import { createSlice } from '@reduxjs/toolkit';

export const bannersSlice = createSlice({
  name: 'banners',
  initialState: {},
  reducers: {
    dismissBanner: (state, action) => {
      state[action.payload] = true;
    },
  },
});

export const { dismissBanner } = bannersSlice.actions;

export default bannersSlice.reducer;
